var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 17 17",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_21272_44487)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.0455 3.7729V13.2275H1.95455V3.7729H15.0455ZM15.0455 2.31836H1.95455C1.15455 2.31836 0.5 2.9729 0.5 3.7729V13.2275C0.5 14.0275 1.15455 14.682 1.95455 14.682H15.0455C15.8455 14.682 16.5 14.0275 16.5 13.2275V3.7729C16.5 2.9729 15.8455 2.31836 15.0455 2.31836Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.06368 7.22798L3.55459 3.77344H1.95459V4.35526L7.15459 8.39162C7.55459 8.68253 8.02732 8.86435 8.50004 8.86435C8.97277 8.86435 9.4455 8.71889 9.8455 8.39162L15.0455 4.35526V3.77344H13.4455L8.97277 7.22798C8.68186 7.44616 8.31823 7.44616 8.06368 7.22798Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_21272_44487"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.5 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.520c855ce851e2edaa582f798fd1a113.svg";
export { ForwardRef as ReactComponent };